<template>
  <div class="bg-gray">
    <div class="form-content">
    <van-pull-refresh v-model="loadingFresh" @refresh="onRefresh">
      <van-list
          v-model="loadingMore"
          :finished="noMore"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <van-cell v-for="item in list" :key="item.id">
            <span slot="default">
                <p>
                    <span>{{item.title}}</span>
                    <span class="list-right" v-if="item.change>0">+{{item.change}}</span>
                    <span class="list-right" v-else>-{{item.change}}</span>
                </p>
<!--                <div style="color: #969799;">{{item.create_time}}</div>-->
            </span>
        </van-cell>

      </van-list>
    </van-pull-refresh>
  </div>
  </div>
</template>
<style scoped>
.van-list >>> p {
  font-size: 16px;
  font-weight: 700;
}

.list-right {
  float: right;
}
</style>

<script>
import Vue from "vue";
import {List, PullRefresh} from "vant";

Vue.use(PullRefresh).use(List);

export default {
  name: 'ClubDetailScore',
  data() {
    return {
      loadingFresh: false,
      loadingMore: false,
      noMore: false,
      params: {
        p: 1,
        step: 10,
      },
      list: []
    };
  },
  mounted() {
    document.title = '积分明细'
    this.getList()
  },

  methods: {
    getList() {
      let that = this;
      that.$api.get('/api/club/scoreList', that.params, res => {
        that.loadingMore = false;

        if (res.data.currentpage == 1) {
          that.list = res.data.list
          that.loadingFresh = false

        } else {
          let list = res.data.list

          list.map(item => {
            that.list.push(item)
          })
        }
        if (res.data.list.length == 0) {
          that.noMore = true;
        }

        this.params.p += 1;

      });
    },
    onLoad() {
      // console.log(1)
      // 异步更新数据
      if (this.params.p > 1) {
        setTimeout(() => {
          this.getList()
        }, 500);
      }
    },

    onRefresh() {
      let that = this;
      that.params.p = 1;
      that.getList();
    },
  }
};
</script>



// WEBPACK FOOTER //
// ClubDetailScore.vue?95052d42